'use client';

import styles from './HiddenFileInput.module.scss';

export type HiddenFileInputProps = {
  dataTestId: string;
  accept: string;
  disabled: boolean;
  multiple?: boolean;
  inputRef: React.RefObject<HTMLInputElement | null>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

/**
 * HiddenFileInput - Reusable hidden file input for FileUpload variants
 *
 * @component
 * @param props - HiddenFileInputProps
 * @returns Hidden file input element
 */
const HiddenFileInput = ({
  dataTestId,
  accept,
  disabled,
  multiple = false,
  inputRef,
  onChange,
}: HiddenFileInputProps) => (
  <input
    ref={inputRef}
    type="file"
    accept={accept}
    multiple={multiple}
    onChange={onChange}
    className={styles.hiddenInput}
    disabled={disabled}
    data-testid={`${dataTestId}-input`}
  />
);

HiddenFileInput.displayName = 'HiddenFileInput';

export default HiddenFileInput;
